import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import CircularProgress from "@mui/material/CircularProgress";

import { appData } from "../app/api/appApiSlice";

import Header from "./Header";
import Footer from "./Footer";
import ActionLoader from "./ActionLoader";

import useAuth from "../hooks/useAuth";

const MainLayout = () => {
  const { loader } = useSelector(appData);
  const { username } = useAuth();

  const [isPageLoading, setIsPageLoading] = useState(true);

  setTimeout(() => {
    setIsPageLoading(false);
  }, 2000);

  if (isPageLoading) {
    return (
      <CircularProgress className="page-laoder top-[calc(50%-20px)] left-[calc(50%-20px)] absolute transform translate-x-[calc(50%-20px)] translate-y-[calc(50%-20px)] !text-black" />
    );
  }

  return (
    <>
      {loader && <ActionLoader />}
      {username && <Header />}
      <main className="container min-h-[calc(100vh-68px)] mx-auto">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default MainLayout;